import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { PageQueryView } from '@/components/customisation/render/page-view';
import { publicPageQuery } from '@/lib/customisation/queries';

export const Route = createFileRoute('/_app/custom/$slug')({ component: CustomPage });

/** A custom page inside the app shell, for signed-in customers. */
function CustomPage() {
  const { slug } = Route.useParams();
  const page = useQuery(publicPageQuery(slug));
  return <PageQueryView query={page} />;
}
